import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppThunk } from 'app/store'
import { User, getUsersV1API } from 'api/usersAPI'
import { RootState } from 'app/rootReducer'

type UserListState = {
  isProcessing: boolean
  error: string
  userList: User[]
}

const initialState: UserListState = {
  isProcessing: true,
  error: '',
  userList: [],
}

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {
    actionStart(state) {
      state.isProcessing = true
    },
    actionFailure(state, action: PayloadAction<string>) {
      state.isProcessing = false
      state.error = action.payload
    },
    actionSuccess(state, action: PayloadAction<User[]>) {
      state.isProcessing = false
      state.error = ''
      state.userList = action.payload
    },
  },
})

export const { actionStart, actionFailure, actionSuccess } = userListSlice.actions

export const selectUserList = (state: RootState) => state.userList.userList

export default userListSlice.reducer

// Thunk start:
export const getUserListV1Thunk = (): AppThunk => async (dispatch) => {
  dispatch(actionStart())
  try {
    dispatch(actionStart())
    const { data } = await getUsersV1API()
    dispatch(actionSuccess(data))
  } catch (err: any) {
    dispatch(actionFailure(err.toString()))
    // TODO: handle fail flow
  }
}
